// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AnnouncementController from "./announcement_controller"
application.register("announcement", AnnouncementController)

import AnnouncementPopupController from "./announcement_popup_controller"
application.register("announcement-popup", AnnouncementPopupController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import ClickToEditController from "./click_to_edit_controller"
application.register("click-to-edit", ClickToEditController)

import ClientPermissionsController from "./client_permissions_controller"
application.register("client-permissions", ClientPermissionsController)

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)

import CollapsingController from "./collapsing_controller"
application.register("collapsing", CollapsingController)

import CollectionController from "./collection_controller"
application.register("collection", CollectionController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import CropPickerController from "./crop_picker_controller"
application.register("crop-picker", CropPickerController)

import EmailTemplatesController from "./email_templates_controller"
application.register("email-templates", EmailTemplatesController)

import FeaturedCarouselController from "./featured_carousel_controller"
application.register("featured-carousel", FeaturedCarouselController)

import FeaturedInventoryController from "./featured_inventory_controller"
application.register("featured-inventory", FeaturedInventoryController)

import FormBuilderController from "./form_builder_controller"
application.register("form-builder", FormBuilderController)

import FormInputController from "./form_input_controller"
application.register("form-input", FormInputController)

import GeocodeController from "./geocode_controller"
application.register("geocode", GeocodeController)

import JobPostsController from "./job_posts_controller"
application.register("job-posts", JobPostsController)

import MobileSelectNavController from "./mobile_select_nav_controller"
application.register("mobile-select-nav", MobileSelectNavController)

import NoUiSliderController from "./no_ui_slider_controller"
application.register("no-ui-slider", NoUiSliderController)

import PaymentFormController from "./payment_form_controller"
application.register("payment-form", PaymentFormController)

import PhotoSelectController from "./photo_select_controller"
application.register("photo-select", PhotoSelectController)

import PhotoSlideshowController from "./photo_slideshow_controller"
application.register("photo-slideshow", PhotoSlideshowController)

import ReadMoreController from "./read_more_controller"
application.register("read-more", ReadMoreController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import ScrollForMoreController from "./scroll_for_more_controller"
application.register("scroll-for-more", ScrollForMoreController)

import ScrollToController from "./scroll_to_controller"
application.register("scroll-to", ScrollToController)

import StatusSelectController from "./status_select_controller"
application.register("status-select", StatusSelectController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TogglerController from "./toggler_controller"
application.register("toggler", TogglerController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import UrlFieldController from "./url_field_controller"
application.register("url-field", UrlFieldController)
